<script setup lang="ts">
import BasePlayer from '@/components/library/player/BasePlayer.vue';

interface Props {
  id: string;
  rendition: {
    source: string;
    mimeType: string;
  };
  route: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div>
    <base-player
      :id="id"
      :key="id"
      :route="route"
      :clean-player="true"
      :player-options="{
        smallPlayer: true,
        autoplay: true,
        muted: true,
        controls: false,
      }"
      :rendition="rendition"
    />
  </div>
</template>

<style scoped lang="postcss">
.player-container {
  @apply block outline-0 border-0;

  & * {
    @apply outline-0 border-0 w-full h-full;

    border-radius: 0 !important;
  }
}

:deep(.player-wrapper__player) {
  @apply w-full h-full object-cover aspect-video;
}
</style>
